import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../axios/Axios.js';
// import "./Modal.css"
import { getToken } from "../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import dayjs, { Dayjs } from 'dayjs';

export default function Modal({ isOpen, onClose }) {
  isOpen = true;
  const MODAL_URL = "/clients";

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const [formData, setFormData] = useState({
    name: '',
    keyword: '',
    time: 0,
    project: false,
    sustain: false,
    startDate: dayjs(),
    endDate: dayjs(),
    logo: null
  });

  const handleSubmit = async () => {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await axiosBackend.post(MODAL_URL, formDataToSend, config);
      console.log('Resposta: ', response.data);
    } catch (error) {
      console.error('Erro ao enviar: ', error);
    }
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <div className={styles.draw_box}>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>Adicionar contrato</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Nome do contrato</label>
              <input
                required
                className={styles.input_box_1}
                placeholder="Escreva o nome do contrato"
                onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
              />
              <small className={styles.helper_text}>ex: FinOps ABC</small>
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Keyword</label>
              <input
                className={styles.input_box_1}
                placeholder="Escreva a chave do contrato"
                onChange={(e) => setFormData({ ...formData, keyword: e.target.value })}
              />
              <small className={styles.helper_text}>ex: VNNCLD</small>
            </div>
          </div>
          <div className={styles.main_row}>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Data inicial</label>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              required={true}
              maxDate={dayjs()}
              value={formData.startDate}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, startDate: newValue })}
              />
            </LocalizationProvider>
          </div>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Data final</label>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              required={true}
              maxDate={dayjs()}
              value={formData.startDate}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, startDate: newValue })}
              />
            </LocalizationProvider>
          </div>
          </div>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Tipo de contrato</label>
              <div className={styles.checkbox_modal}>
                <label>
                  <input type="checkbox" name="type" value="Projeto" onChange={(e) => setFormData({ ...formData, project: e.target.checked})}/>
                  Projeto
                </label>
                <label>
                  <input type="checkbox" name="type" value="Sustentação" onChange={(e) => setFormData({ ...formData, sustain: e.target.checked})}/>
                  Sustentação
                </label>
              </div>
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Horas contratadas</label>
              <TextField
                id="outlined-number"
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                value={formData.time}
                min={0}
                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
              />
            </div>
          </div>
          {/* bymonth?? */}
          <div className={styles.main_row}>
            <button className={styles.cancel_button} onClick={console.log(formData)}>
              Cancelar
            </button>
            <button
              className={styles.send_button}
              onClick={() => {
                handleSubmit();
                onClose();
              }}
            >
              Adicionar
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}